import TransactionContext from "providers/TransactionProvider/TransactionContext"

export default function TransactionProvider ({transaction, children}){
  return(
      <TransactionContext.Provider value={transaction}>
        {children}
      </TransactionContext.Provider>
  )
}
